export const SOCIAL_LINKS = [
  {
    id: 'instagram-gniark',
    href: 'https://www.instagram.com/gniark.gniark/',
    network: 'instagram',
    labelKey: 'footer.social.instagramGniark',
  },
  {
    id: 'instagram-ravenlabz',
    href: 'https://www.instagram.com/ravenlabz1/',
    network: 'instagram',
    labelKey: 'footer.social.instagramRavenlabz',
  },
  {
    id: 'linkedin-gniark',
    href: 'https://www.linkedin.com/company/gniarkgniark/',
    network: 'linkedin',
    labelKey: 'footer.social.linkedinGniark',
  },
  {
    id: 'linkedin-leagora',
    href: 'https://www.linkedin.com/company/leagora/',
    network: 'linkedin',
    labelKey: 'footer.social.linkedinLeagora',
  },
];

export const SOCIAL_SAME_AS = SOCIAL_LINKS.map((link) => link.href);
